module.exports = __webpack_public_path__ + "static/img/73-1.d50d0bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/73-1.jpg
// module id = q4Nx
// module chunks = 0